export class TempoExecucao {
    nomeUsuario: String;
    codigoTipo: String;
    dataInicioExecucao: String;
    dataFimExecucao: String;
    dataInicioExecucaoTexto: String;
    dataFimExecucaoTexto: String;
    descricaoRequisicao: String;
    tempoExecucaoSegundos: String;
    codigoTipoAssinatura: String;
    totalAssinaturas: String;
    origemRequisicao: String;
}